import marketplace from 'cfg/marketplace.json';

const { checkout: { checkoutUrlMelodyOcelot } } = marketplace;

export const CART_STEP = -10;
export const TBD_STEP = 1;

export const NEW_ADDRESS_STEP = 14;
export const EDIT_ADDRESS_STEP = 15;
export const LIST_ADDRESS_STEP = 16;

export const PAYMENT_STEP = 22;

export const EDIT_BILLING_ADDRESS_STEP = 26;
export const NEW_BILLING_ADDRESS_STEP = 27;
export const SELECT_BILLING_ADDRESS_STEP = 29;

export const SHIP_OPTIONS_STEP = 30;
export const GIFT_OPTIONS_STEP = 35;
export const REVIEW_STEP = 50;
export const UNKNOWN_STEP = 100;

export const CHECKOUT_PAGE_MAP = {
  [LIST_ADDRESS_STEP]: 'address',
  [REVIEW_STEP]: 'spc',
  [PAYMENT_STEP]: 'pay'
};

export const CHECKOUT_URL_MAP = {
  [`${checkoutUrlMelodyOcelot}/address/edit`]: EDIT_ADDRESS_STEP,
  [`${checkoutUrlMelodyOcelot}/address/new`]: NEW_ADDRESS_STEP,
  [`${checkoutUrlMelodyOcelot}/address`]: LIST_ADDRESS_STEP,
  [`${checkoutUrlMelodyOcelot}/billing/edit`]: EDIT_BILLING_ADDRESS_STEP,
  [`${checkoutUrlMelodyOcelot}/billing/new`]: NEW_BILLING_ADDRESS_STEP,
  [`${checkoutUrlMelodyOcelot}/billing`]: SELECT_BILLING_ADDRESS_STEP,
  [`${checkoutUrlMelodyOcelot}/giftoptions`]: GIFT_OPTIONS_STEP,
  [`${checkoutUrlMelodyOcelot}/initiate`]: TBD_STEP,
  [`${checkoutUrlMelodyOcelot}/payment`]: PAYMENT_STEP,
  [`${checkoutUrlMelodyOcelot}/shipoption`]: SHIP_OPTIONS_STEP,
  [`${checkoutUrlMelodyOcelot}/spc`]: REVIEW_STEP,
  [checkoutUrlMelodyOcelot]: TBD_STEP
};

export const CHECKOUT_STEP_MAP = {
  [EDIT_ADDRESS_STEP]: `${checkoutUrlMelodyOcelot}/address/edit`,
  [EDIT_BILLING_ADDRESS_STEP]: `${checkoutUrlMelodyOcelot}/billing/edit`,
  [GIFT_OPTIONS_STEP]: `${checkoutUrlMelodyOcelot}/giftoptions`,
  [LIST_ADDRESS_STEP]: `${checkoutUrlMelodyOcelot}/address`,
  [NEW_ADDRESS_STEP]: `${checkoutUrlMelodyOcelot}/address/new`,
  [NEW_BILLING_ADDRESS_STEP]: `${checkoutUrlMelodyOcelot}/billing/new`,
  [PAYMENT_STEP]: `${checkoutUrlMelodyOcelot}/payment`,
  [REVIEW_STEP]: `${checkoutUrlMelodyOcelot}/spc`,
  [SELECT_BILLING_ADDRESS_STEP]: `${checkoutUrlMelodyOcelot}/billing`,
  [SHIP_OPTIONS_STEP]: `${checkoutUrlMelodyOcelot}/shipoption`,
  [TBD_STEP]: checkoutUrlMelodyOcelot
};
